export type CancellationPolicy = {
    id: CancellationPolicyId;
    displayName: string;
    fiftyPercentRefundDeadlineDays: number;
    noRefundDeadlineDays: number;
    paymentDeadlineDays: number;
    isDefault: boolean;
};

export type CancellationPolicyId = 'LEGACY' | 'FLEXIBLE' | 'MODERATE' | 'STRICT';

export const createCancellationPolicies = (data: Record<string, unknown>[]): CancellationPolicy[] =>
    data.map(
        (policy): CancellationPolicy => ({
            id: policy.id as CancellationPolicyId,
            displayName: policy.displayName as string,
            fiftyPercentRefundDeadlineDays: policy.fiftyPercentRefundDeadlineDays as number,
            noRefundDeadlineDays: policy.noRefundDeadlineDays as number,
            paymentDeadlineDays: policy.paymentDeadlineDays as number,
            isDefault: policy.isDefault as boolean,
        }),
    );

export const createCancellationPolicy = (data: Record<string, unknown>): CancellationPolicy => {
    const cancellationPolicy: Partial<CancellationPolicy> = {
        id: (data.id as CancellationPolicyId) ?? undefined,
        displayName: (data.displayName as string) ?? undefined,
        fiftyPercentRefundDeadlineDays: Number(data.fiftyPercentRefundDeadlineDays) ?? undefined,
        noRefundDeadlineDays: Number(data.noRefundDeadlineDays) ?? undefined,
        paymentDeadlineDays: Number(data.paymentDeadlineDays) ?? undefined,
        isDefault: (data.isDefault as boolean) ?? undefined,
    };
    return {
        ...(cancellationPolicy as CancellationPolicy),
    };
};
